import { Currency } from '../components/transactions-sidepanels/types';

const formatBalance = (
  balance: number,
  currency?: Currency,
  minDegits?: number,
) => {
  const formattedString = balance
    .toLocaleString(undefined, {
      minimumFractionDigits: minDegits?.toString() ? minDegits : 2,
      maximumFractionDigits: currency?.decimals || 2,
    })
    .replace(/\u00a0/g, ' ');

  return formattedString;
};

export default formatBalance;
